import { Routes } from '@angular/router';
import { AuthGuard } from '@core/shared';
import { CashrewardsComponent } from './cashrewards.component';
import { CashRewardsTransactionsComponent } from './transactions/transactions.component';

export const CashRewardsRoute: Routes = [
    {
      path: 'cashrewards',
      canActivate: [AuthGuard],
      component: CashrewardsComponent,
      pathMatch: 'full',
      data: { title: 'PageTitles.CashRewards', isPreLogin: false }
    },
    {
      path: 'cashrewards/transactions',
      canActivate: [AuthGuard],
      component: CashRewardsTransactionsComponent,
      pathMatch: 'full',
      data: { title: 'Cash Rewards Transactions', isPreLogin: false }
    }
];

